/**
 * Armazenamento da sessão.
 *
 * No navegador (desenvolvimento) usa localStorage.
 * Quando o app rodar no Capacitor, este módulo passa a usar o armazenamento
 * seguro do dispositivo, sem mudar quem o consome.
 */
export const storage = {
  get(key) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* armazenamento indisponível: a sessão vale só enquanto a página estiver aberta */
    }
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch {
      /* idem */
    }
  },
};
